import AppLogic from "AppLogic";

const getOrginizationDetails = (targetCountry) => {
  return AppLogic.getAxios().get(`organization-profile/info?targetCountry=${targetCountry}`).then((response) => {
    return response.data;
  });
};

const getTeamMembers = ({ page = 0, size = 0 }) => {
  return AppLogic.getAxios()
    .get(`organization-profile/get-members?page=${page}&size=${size}`)
    .then((response) => {
      return response.data;
    });
};

const getTenantContent = (contentType) =>
  AppLogic.getAxios()
    .get(`organization-profile/content/${contentType}`)
    .then((response) => response.data);

const saveTenantContentSelection = (contentType, contentIds) =>
  AppLogic.getAxios()
    .put(`organization-profile/content/${contentType}/selection`, { contentIds })
    .then((response) => response.data);

const getTenantDomains = () =>
  AppLogic.getAxios()
    .get("organization-profile/domains")
    .then((response) => response.data);

const saveTenantDomains = (domains) =>
  AppLogic.getAxios()
    .put("organization-profile/domains", { domains })
    .then((response) => response.data);

const getTenantStatus = () =>
  AppLogic.getAxios()
    .get("organization-profile/tenant-status")
    .then((response) => response.data);

const orginizationService = {
  getOrginizationDetails,
  getTeamMembers,
  getTenantContent,
  saveTenantContentSelection,
  getTenantDomains,
  saveTenantDomains,
  getTenantStatus,
};

export default orginizationService;
